import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import DateHelper, {DATE_FORMAT} from '../helpers/DateHelper';
import 'react-datepicker/dist/react-datepicker.css';

class Dates extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        let {startDate, endDate} = this.props;

        const startTimeStampMs = startDate.input.value * 1000;
        const endTimeStampMs = endDate.input.value * 1000;

        const startDateFormatted = moment.utc(startTimeStampMs).format(DATE_FORMAT);
        const endDateFormatted = moment.utc(endTimeStampMs).format(DATE_FORMAT);

        return (
            <div className="row">
                <div className="col-6">
                    <DatePicker
                        fixedHeight={true}
                        {...startDate.input}
                        value={startDateFormatted}
                        className="form-control"
                        dateFormat={DATE_FORMAT}
                        locale={moment.locale()}
                        selected={moment.utc(startTimeStampMs)}
                        maxDate={moment.utc().endOf('day')}
                        utcOffset={0}
                        onChange={momentDate => {
                            let momentDateMsTimestamp = momentDate.startOf('day').unix();
                            startDate.input.onChange(momentDateMsTimestamp);
                        }}
                        onBlur={() => {}}
                    />
                </div>
                <div className="col-6">
                    <DatePicker
                        {...endDate.input}
                        value={endDateFormatted}
                        className="form-control"
                        dateFormat={DATE_FORMAT}
                        locale={moment.locale()}
                        selected={moment.utc(endTimeStampMs)}
                        minDate={moment.utc(startTimeStampMs)}
                        maxDate={moment.utc().endOf('day')}
                        utcOffset={0}
                        onChange={momentDate => {
                            let momentDateMsTimestamp = momentDate.endOf('day').unix();
                            endDate.input.onChange(momentDateMsTimestamp);
                        }}
                        onBlur={() => {}}
                    />
                </div>
            </div>
        );
    }
}

export default Dates;


// WEBPACK FOOTER //
// ./web/src/components/charts/Dates.jsx